"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const RegistrationPage_vue_1 = __importDefault(require("../../pages/registrationPage/RegistrationPage.vue"));
exports.default = [
    {
        name: "registration_page",
        path: "/registration",
        component: RegistrationPage_vue_1.default,
        meta: { requiresAuth: false, title: "Registration page" },
    },
];
